import React from "react"

import { FormControl, FormControlLabel, FormHelperText, FormLabel, Input, Radio, RadioGroup, TextareaAutosize, Typography } from "@material-ui/core"
import { criteriaGradingRules } from "../../Constants"
import CustomCardItem from "../Cards/CustomCardItem"

const AttributionView = ({ hasCoi, needsChanges, comment, coiText, observation, accepted, grades, accessCode }) => {
    return (
        <>
            <CustomCardItem>
                <Typography variant="h3">Avaliação de {accessCode}</Typography>

                {/* Conflito de interesse ou não */}
                <FormControl component="fieldset">
                    <FormLabel component="legend">Declaro que possuo conflito de interesses para este trabalho</FormLabel>
                    <RadioGroup name="hasCoi" value={hasCoi}>
                        <FormControlLabel value={"true"} control={<Radio />} label="Sim" />
                        <FormControlLabel value={"false"} control={<Radio />} label="Não" />
                    </RadioGroup>
                </FormControl>
                <br /><br />
                {
                    hasCoi != null &&
                    <>
                        {
                            hasCoi === 'true' ?
                                <>
                                    <TextareaAutosize
                                        maxRows={10}
                                        name="coiText"
                                        value={coiText}
                                        required
                                        aria-describedby="coiText-helper"
                                    />
                                    <FormHelperText id={"coiText-helper"}>Descreva o conflito de interesse</FormHelperText>

                                </>
                                :
                                <>
                                    {/* Aceito ou não */}
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend">Este trabalho cumpriu as normas do evento?</FormLabel>
                                        <RadioGroup name="accepted" value={accepted}>
                                            <FormControlLabel value={"true"} control={<Radio />} label="Sim" />
                                            <FormControlLabel value={"false"} control={<Radio />} label="Não" />
                                        </RadioGroup>
                                    </FormControl>

                                    {
                                        accepted !== null &&
                                        <>
                                            {
                                                (accepted === 'true') ?
                                                    <div>
                                                        <FormControl component="fieldset">
                                                            <FormLabel component="legend">O trabalho necessita de alterações?</FormLabel>
                                                            <RadioGroup name="needsChanges" value={needsChanges}>
                                                                <FormControlLabel value={"true"} control={<Radio />} label="Sim" />
                                                                <FormControlLabel value={"false"} control={<Radio />} label="Não" />
                                                            </RadioGroup>
                                                        </FormControl>

                                                        {
                                                            criteriaGradingRules.map((c, i) => (
                                                                <div key={i}>
                                                                    <Input
                                                                        type="number"
                                                                        fullWidth
                                                                        name={c.name}
                                                                        value={grades[c.name] || ""}
                                                                        required
                                                                        aria-describedby={c.name + "-helper"}
                                                                        inputProps={{
                                                                            max: 10,
                                                                            maxLength: 4,
                                                                            min: 0
                                                                        }}
                                                                    />
                                                                    <FormHelperText id={c.name + "-helper"}>{c.title}</FormHelperText>
                                                                </div>
                                                            ))
                                                        }

                                                        <TextareaAutosize
                                                            maxRows={10}
                                                            name="comment"
                                                            value={comment}

                                                            required
                                                            aria-describedby={"comment-helper"}
                                                        />
                                                        <FormHelperText id={"comment-helper"}>Comentário: parecer do aceite</FormHelperText>

                                                    </div>
                                                    :
                                                    <div>
                                                        <Typography>Caso o trabalho não cumpra as normas no evento, você deve preencher o campo abaixo</Typography>

                                                        <TextareaAutosize
                                                            maxRows={10}
                                                            name="observation"
                                                            value={observation}

                                                            required
                                                            aria-describedby={"observation-helper"}
                                                        />
                                                        <FormHelperText id={"observation-helper"}>Observação: descrição da recusa</FormHelperText>

                                                    </div>
                                            }
                                        </>
                                    }

                                </>
                        }
                    </>
                }

            </CustomCardItem>
        </>
    )
}

export default AttributionView;
